import { apiList } from '../mixtiles-web-common/services/apiService'
import { ART_API_PATH } from '../Art/config/art-consts'
import { type Artwork } from '../types/art.types'

const PATH = `${ART_API_PATH}/artworks`

type PerCategoryResponse = {
  list: {
    id: string
    name: string
    artworks: Artwork[]
  }[]
}

export const getArtworksPerCategory = async ({
  categoryNames,
  limit = undefined,
  variant,
}: {
  categoryNames: string[]
  limit?: number
  variant?: string
}) => {
  return apiList<PerCategoryResponse>(`${PATH}/per-category`, {
    categoryNames,
    limit,
    variant,
  })
}
